import Snackbar from "@mui/material/Snackbar";

export const PositionedSnackbar = ({ open, onClose, position = { vertical: "top", horizontal: "center" }, children, sx }) => {
  const { vertical, horizontal } = position;

  const isStaging = process.env.REACT_APP_NODE_ENV === "staging";
  const isTopPosition = vertical === "top";
  const mobileTopOffset = 56 + (isStaging ? 40 : 0) + 8;
  const desktopTopOffset = 64 + (isStaging ? 40 : 0) + 8;

  const baseStyles = {
    ...(isTopPosition && {
      top: {
        xs: `${mobileTopOffset}px !important`,
        sm: `${desktopTopOffset}px !important`,
      },
    }),

    maxWidth: {
      xs: "calc(100% - 16px)",
      sm: "calc(100% - 32px)",
    },
  };

  const customStyles = Array.isArray(sx) ? sx : [sx];

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={onClose}
      key={`${vertical}-${horizontal}`}
      sx={[baseStyles, ...customStyles].filter(Boolean)}
    >
      {children}
    </Snackbar>
  );
};
